<template>
  <div class="header-label-tipo-acuerdo-sidesheet-acuerdo-comercial">

    <!-- Titulo principal -->
    <div class="d-flex align-center justify-space-between" v-if="mostrar_texto_titulo">

      <!-- Header según el tipo de acuerdo comercial -->
      <div class="titulo-header">
        {{ acuerdo_comercial.tipo_propuesta === TIPO_ACUERDO_CONSORCIO ? 'Acuerdo comercial de consorcio' : 'Acuerdo comercial por defecto' }}
      </div>

      <!-- Ticket Jira -->
      <ca-tooltip-jira
        v-if="acuerdo_comercial.tipo_propuesta === TIPO_ACUERDO_CONSORCIO"
        :ticket_jira="acuerdo_comercial.ticketJira"
        mostrar_texto_ticket
      >
        {{ acuerdo_comercial.ticketJira }}
      </ca-tooltip-jira>

    </div>

    <!-- Subtitulos -->
    <div class="d-flex flex-column mt-3">

      <!-- Administración -->
      <div class="d-flex align-center subtitulo-header">
        <div class="subtitulo-header--oscuro mr-1">Administración:</div>
        <div> {{ textoSubtituloFormateado(TIPO_ACUERDO_ADMINISTRACION) }} </div>
      </div>

      <!-- Consorcio -->
      <div v-if="acuerdo_comercial.tipo_propuesta === TIPO_ACUERDO_CONSORCIO">
        <div class="d-flex align-center subtitulo-header">
          <div class="subtitulo-header--oscuro mr-1">Consorcio:</div>
          <div>{{ textoSubtituloFormateado(TIPO_ACUERDO_CONSORCIO) }}</div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import { TipoAcuerdo } from '../acuerdo-comercial.consts';
import AcuerdoComercial from '../AcuerdoComercial.vue';

/**
 * Header de labels de administración y consorcio para los sidesheets de visualización/edición y eliminación de acuerdos comerciales
 * 
 * Cada uno de los sidesheets invocará este componente para usarlo como header del mismo
 * Los labels de los headers estan formateados y condicionados según el tipo de acuerdo seleccionado
 */
export default {
  name: 'HeaderLabelTipoAcuerdoComercialSidesheet',
  props: {
    acuerdo_comercial: { type: AcuerdoComercial, default: null },
    mostrar_texto_titulo: { type: Boolean, default: true} , // Flag para mostrar el texto del titulo principal del header
  },
  data: () => ({
    TIPO_ACUERDO_ADMINISTRACION: TipoAcuerdo.ADMINISTRACION,
    TIPO_ACUERDO_CONSORCIO: TipoAcuerdo.CONSORCIO,
  }),
  methods: {

    /**
     * Retorna el texto del subtitulo formateado según el tipo de acuerdo que recibió por parámetro 
     * 
     * Consorcio: NOMBRE DEL CONSORCIO (id)
     * Por defecto: Nombre de la administración (id)
     */
    textoSubtituloFormateado(tipo_acuerdo) {
      let subtitulo_formateado = null; // Variable para almacenar el subtitulo formateado

      // Si el tipo de acuerdo es consorcio
      if(tipo_acuerdo === TipoAcuerdo.CONSORCIO) {
        subtitulo_formateado = this.acuerdo_comercial.consorcio.nombre.toUpperCase();
        subtitulo_formateado += ' (' + this.acuerdo_comercial.consorcio.id + ')';
      } else { // Por defecto (administración)
        subtitulo_formateado = this.acuerdo_comercial.administracion.nombre;
        subtitulo_formateado += ' (' + this.acuerdo_comercial.administracion.id + ')';
      }

      return subtitulo_formateado;
    }
  }
};
</script>

<style lang="scss">
.header-label-tipo-acuerdo-sidesheet-acuerdo-comercial {

  .titulo-header {
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    color: color(dark-secund);
  }

  .subtitulo-header {
    color: color(gris-oscuro);
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;

    &--oscuro {
      font-weight: 700;
    }
  }
}
</style>